'use client'

import { memo } from 'react'
import { CRAFT_MEDIA } from './craft-media'

const VALUE_PROPS = [
  {
    title: 'Private by default',
    description:
      'Chats, tools, and inference stay on your device. Cloud plugins are strictly opt-in.',
    icon: CRAFT_MEDIA.icons.shield,
    stat: '0',
    statLabel: 'cloud calls by default',
    placement: 'right-mid-cw',
  },
  {
    title: 'Instant & lightweight',
    description: '~20 MB installer. Cold start in seconds. Local streaming with zero latency.',
    icon: CRAFT_MEDIA.icons.bolt,
    stat: '~20MB',
    statLabel: 'installer size',
    placement: 'right-high-ccw',
  },
  {
    title: 'Agentic & automatable',
    description:
      'NinCrew, browser agents, on-device voice, local shell, web tools, and automations that run locally.',
    icon: CRAFT_MEDIA.adam.modelAgent,
    stat: '10+',
    statLabel: 'local tool types',
    placement: 'corner-bottom-cw',
  },
  {
    title: 'Your keys, your models',
    description:
      'Use powerful local GGUF models or bring your own OpenAI, Anthropic, or Google keys.',
    icon: CRAFT_MEDIA.icons.key,
    stat: 'BYOK',
    statLabel: 'bring your own keys',
    placement: 'left-mid-ccw',
  },
] as const

/**
 * baby: Why NINX: cream craft paper cards with overflowing papercraft icons.
 */
export const CraftValueProps = memo(function CraftValueProps() {
  return (
    <div className="craft-values" data-testid="craft-value-props">
      <div className="craft-values__header">
        <p className="craft-section__eyebrow">Why NINX</p>
        <h2 className="craft-section__title">
          Everything you expect. Nothing leaves your machine.
        </h2>
      </div>

      <ul className="craft-values__grid">
        {VALUE_PROPS.map((item, index) => (
          <li
            key={item.title}
            className={`craft-values__item craft-values__item--r${(index % 4) + 1}`}
          >
            <span className="craft-values__tape" aria-hidden />
            <div className="craft-values__asset" aria-hidden>
              <img
                src={item.icon}
                alt=""
                className={`craft-values__icon craft-values__icon--${item.placement}`}
                draggable={false}
              />
            </div>
            <div className="craft-values__copy">
              <div className="craft-values__stat">
                <span className="craft-values__stat-num">{item.stat}</span>
                <span className="craft-values__stat-label">{item.statLabel}</span>
              </div>
              <h3 className="craft-values__title">{item.title}</h3>
              <p className="craft-values__body">{item.description}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
})

CraftValueProps.displayName = 'CraftValueProps'
